import { parseIsCardPresent } from "./Insurance/insuranceProviders";

export const normalizePaymentTypeValue = (value) => {
  if (!value) {
    return null;
  }
  const normalized = String(value).toLowerCase();
  if (normalized === "insurance" || normalized === "selfpay") {
    return normalized;
  }
  return null;
};

export const parseSavePaymentTypeResponse = (response) => {
  const data = response?.data ?? response ?? {};
  return {
    paymentType: normalizePaymentTypeValue(
      data.payment_type ?? data.paymentType
    ),
    isCardPresent: parseIsCardPresent(
      data.is_card_present ?? data.isCardPresent
    ),
  };
};

export const getStoredPaymentTypeFields = (registrationData = {}) => {
  const fromResponse = registrationData.savePaymentTypeResponse ?? {};
  return {
    paymentType:
      normalizePaymentTypeValue(
        registrationData.paymentType ??
          fromResponse.payment_type ??
          fromResponse.paymentType
      ) ?? null,
    isCardPresent: parseIsCardPresent(
      registrationData.isCardPresent ??
        fromResponse.is_card_present ??
        fromResponse.isCardPresent
    ),
  };
};

export const getPostSavePaymentTypeRoute = ({ paymentType, isCardPresent }) => {
  if (paymentType === "insurance") {
    return "/register/account/insurance";
  }
  if (paymentType === "selfpay") {
    return isCardPresent
      ? "/register/account/dietitians"
      : "/register/account/card";
  }
  return null;
};
